import { type Static, Type } from "@sinclair/typebox"
import { Nullable } from "./common"

// Branding white-label — docs/04 §2-§3 y docs/03 §3.
// Sirve tanto para la instancia (GET /v1/branding, GET/PUT /admin/branding) como para
// el override por dominio (GET /v1/branding/{domain}, PUT /admin/domains/{id}/branding) [V1].

export const ThemeModeSchema = Type.Union([
  Type.Literal("light"),
  Type.Literal("dark"),
  Type.Literal("system"),
])
export type ThemeMode = Static<typeof ThemeModeSchema>

export const BrandingColorsSchema = Type.Object({
  // Hex de 6 dígitos; paleta extendida en V2
  primary: Type.String({ pattern: "^#[0-9a-fA-F]{6}$" }),
})
export type BrandingColors = Static<typeof BrandingColorsSchema>

export const BrandingSchema = Type.Object({
  product_name: Type.String(),
  logo_url: Nullable(Type.String()),
  // Variante para modo oscuro [V1]; si falta, la UI adapta el logo automáticamente
  logo_dark_url: Nullable(Type.String()),
  colors: BrandingColorsSchema,
  theme_mode: ThemeModeSchema,
})
export type Branding = Static<typeof BrandingSchema>

// El logo se sube aparte por multipart (POST /admin/branding/logo).
export const UpdateBrandingRequestSchema = Type.Object({
  product_name: Type.Optional(Type.String({ minLength: 1 })),
  colors: Type.Optional(BrandingColorsSchema),
  theme_mode: Type.Optional(ThemeModeSchema),
})
export type UpdateBrandingRequest = Static<typeof UpdateBrandingRequestSchema>

// POST /admin/branding/logo — multipart (png/svg/webp ≤ 1 MB); el file lo valida la API.
export const UploadLogoResponseSchema = Type.Object({
  logo_url: Type.String(),
})
export type UploadLogoResponse = Static<typeof UploadLogoResponseSchema>
